<div class="form-container">
  <alert></alert>
  <h2>Partner: {{ partner.name }}</h2>
  @if (!loading && partner) {
    <div class="col-md-8 pl0">
        <ng-container *ngTemplateOutlet="infoRow; context: { 
            key: 'Partner UUID', value: partner.id
        }"></ng-container>
        <ng-container *ngTemplateOutlet="infoRow; context: { 
            key: 'Partner name', value: partner.name
        }"></ng-container>
        <ng-container *ngTemplateOutlet="infoRow; context: { 
            key: 'Email', value: partner.email
        }"></ng-container>
      <div class="row">
        <div class="col-md-3">Status</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">
          @if (partner.status=='active') {
            <span class="badge badge-success">{{partner.status}}</span>
          }
          @if (partner.status=='inactive') {
            <span class="badge badge-secondary">{{partner.status}}</span>
          }
        </div>
      </div>
        <ng-container *ngTemplateOutlet="infoRow; context: { 
            key: 'Phone', value: partner.phone
        }"></ng-container>
        <ng-container *ngTemplateOutlet="infoRow; context: { 
            key: 'Country', value: partner.country
        }"></ng-container>
      <div class="row">
        <div class="col-md-3">Admins</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">
          @for (admin of partner.admins; track admin; let last = $last) {
            <span>
              {{ admin.email }}
              @if (!last) {
                <span>, </span>
              }
            </span>
          }
        </div>
      </div>
      <div class="row footer">
        <a [routerLink]="['/dashboard/partner/list']" class="btn btn-sm btn-primary">Back to Partner List</a>
        @if (!deleted) {
          <a [routerLink]="['/dashboard/partner/edit/',(partner.id)]" class="btn btn-sm btn-edit"
            [state]="{ data: { view: 'edit', partner: partner }}" title="Edit Partner">
            <i class="fa fa-fw fa-edit"></i> Edit
          </a>
        }
        @if (!deleted) {
          <a class="btn btn-delete btn-sm" href="javascript:;" (click)="deletePartner()"
            title="Delete Partner"><i class="fa fa-fw fa-trash"></i> Delete</a>
          }
        </div>
      </div>
    }
  </div>


  <ng-template #infoRow let-key="key" let-value="value">
    <div class="row">
      <div class="col-md-3">{{ key }}</div>
      <div class="col-md-1">:</div>
      <div class="col-md-7">{{ value }}</div>
    </div>
  </ng-template>
